import { Box, Skeleton, Stack } from "@mui/material";


export default function LoadingSkelaton()
{
    return(
        <Box>
          <Box className={"skelaton-market"}>
            <Stack direction={"row"} alignItems={"center"} paddingLeft={2}>
              <Skeleton variant='circular' width={20} />
              <Box className={"skelaton-title-box"}>
                    <Skeleton variant="rectangular" className="skelaton-title"></Skeleton>
              </Box>
            </Stack>
          </Box>
          <Box className={"skelaton-market"}>
            <Stack direction={"row"} alignItems={"center"} paddingLeft={2}>
              <Skeleton variant='circular' width={15} height={15} />
              <Box className={"skelaton-title-box"}>
                    <Skeleton variant="rectangular" className="skelaton-title"></Skeleton>
              </Box>
            </Stack>
          </Box>
    
          <Box className={"skelaton-market"}>
              <Stack spacing={1} justifyContent={"center"} paddingLeft={2} flex={1}>
                <Skeleton variant='rounded' height={6} width={"75%"} ></Skeleton>
                <Skeleton variant='rounded' height={6} width={"50%"} ></Skeleton>
              </Stack>
              <Skeleton variant="rectangular" className="skelaton-empty-buttons"></Skeleton>
          </Box>
          <Box className={"skelaton-market"}>
              <Stack spacing={1} justifyContent={"center"} paddingLeft={2} flex={1}>
                <Skeleton variant='rounded' height={6} width={"75%"} ></Skeleton>
                <Skeleton variant='rounded' height={6} width={"50%"} ></Skeleton>
              </Stack>
              <Skeleton variant="rectangular" className="skelaton-empty-buttons"></Skeleton>
          </Box>
          <Box className={"skelaton-market"}>
              <Stack spacing={1} justifyContent={"center"} paddingLeft={2} flex={1}>
                <Skeleton variant='rounded' height={6} width={"75%"} ></Skeleton>
                <Skeleton variant='rounded' height={6} width={"50%"} ></Skeleton>
              </Stack>
              <Skeleton variant="rectangular" className="skelaton-empty-buttons"></Skeleton>
          </Box>
    
          <Box className={"skelaton-market"}>
            <Stack direction={"row"} alignItems={"center"} paddingLeft={2}>
              <Skeleton variant='circular' width={15} height={15} />
              <Box className={"skelaton-title-box"}>
                    <Skeleton variant="rectangular" className="skelaton-title"></Skeleton>
              </Box>
            </Stack>
          </Box>
    
          <Box className={"skelaton-market"}>
              <Stack spacing={1} justifyContent={"center"} paddingLeft={2} flex={1}>
                <Skeleton variant='rounded' height={6} width={"75%"} ></Skeleton>
                <Skeleton variant='rounded' height={6} width={"50%"} ></Skeleton>
              </Stack>
              <Skeleton variant="rectangular" className="skelaton-empty-buttons"></Skeleton>
          </Box>
        </Box>
      )
}